/**
 * PersonalTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const PersonalTab = ({ ctx }) => {
  const {
    formData,
    handlePersonalChange,
  } = ctx;

  return (
          <TabsContent value="personal">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <User className="w-5 h-5 text-stone-700" />
                  Personal Information (Infotype 0002)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>First Name *</Label>
                    <Input
                      value={formData.personal_data.first_name}
                      onChange={(e) => handlePersonalChange('first_name', e.target.value)}
                      placeholder="John"
                    />
                  </div>
                  <div>
                    <Label>Middle Name</Label>
                    <Input
                      value={formData.personal_data.middle_name}
                      onChange={(e) => handlePersonalChange('middle_name', e.target.value)}
                      placeholder="William"
                    />
                  </div>
                  <div>
                    <Label>Last Name *</Label>
                    <Input
                      value={formData.personal_data.last_name}
                      onChange={(e) => handlePersonalChange('last_name', e.target.value)}
                      placeholder="Doe"
                    />
                  </div>
                  <div>
                    <Label>Date of Birth *</Label>
                    <Input
                      type="date"
                      value={formData.personal_data.date_of_birth}
                      onChange={(e) => handlePersonalChange('date_of_birth', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Gender *</Label>
                    <select
                      value={formData.personal_data.gender}
                      onChange={(e) => handlePersonalChange('gender', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="O">Other</option>
                    </select>
                  </div>
                  <div>
                    <Label>Marital Status</Label>
                    <select
                      value={formData.personal_data.marital_status}
                      onChange={(e) => handlePersonalChange('marital_status', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="S">Single</option>
                      <option value="M">Married</option>
                      <option value="D">Divorced</option>
                      <option value="W">Widowed</option>
                    </select>
                  </div>
                  <div>
                    <Label>Nationality</Label>
                    <Input
                      value={formData.personal_data.nationality}
                      onChange={(e) => handlePersonalChange('nationality', e.target.value)}
                      placeholder="Indian"
                    />
                  </div>
                  <div>
                    <Label>Birth Place</Label>
                    <Input
                      value={formData.personal_data.birth_place}
                      onChange={(e) => handlePersonalChange('birth_place', e.target.value)}
                      placeholder="City, Country"
                    />
                  </div>
                  <div>
                    <Label>Blood Group</Label>
                    <select
                      value={formData.personal_data.blood_group}
                      onChange={(e) => handlePersonalChange('blood_group', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="">Select</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                    </select>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default PersonalTab;
